import { lokiStream } from "./lokiStream";

export const lokiStreams = {
  type: "array",
  minItems: 0,
  maxItems: 1_024,
  items: lokiStream
};
